import React from "react"
import IDCopy from "../../ui/IDCopy"
import PropTypes from "prop-types"
import Pill from "../../ui/Pill"
import styled from "styled-components"

const ObjectID = styled.span`
  font-size: 0.9em;
  opacity: 0.7;
`

/**
 * Renders a resident space object for use as an item in a list.
 * Includes the ID being hotlinked to the RSO detail page, as well
 * as the ability to copy the ID by clicking the copy icon.
 */
const RSOInfo = ({
  id,
  object_name,
  object_id,
  object_type,
  updated,
  source,
}) => (
  <div title={object_id}>
    <div>
      <span>
        {object_name || "-"} {object_id && <ObjectID>({object_id})</ObjectID>}
        {source == "user" && <Pill>custom</Pill>}
      </span>
    </div>

    {id && <IDCopy id={id} linkTo={`/rsos/${id}`} showCopy />}
    {object_type && (
      <div>
        Type: <span>{object_type.toLocaleLowerCase()}</span>
      </div>
    )}
    {updated && (
      <div>
        Updated: <span>{updated}</span>
      </div>
    )}
  </div>
)

RSOInfo.propTypes = {
  id: PropTypes.string, // The Norad id for the RSO
  object_name: PropTypes.string, // Human-readable name of the object
  object_id: PropTypes.string, //
  object_type: PropTypes.string, // The Norad classification of this object e.g. Debris, Payload, etc
  updated: PropTypes.string, // The last time the Astrosite was updated
  source: PropTypes.string, // "user" or "spacetrack"
}

export default RSOInfo
